import React, { useEffect, useState } from "react";
import "../assets/imageslider.css";
import useTitanApp from "../hooks/useTitanApp";
import noimage from "../assets/images/No-Image-Placeholder.svg.png";
import { Skeleton } from "@mui/material";

function ImageSlider({ navigateFrom }) {
  const { clincicalChecksState, nmsServiceState, appState } = useTitanApp();
  const { patientImage, isClinicalChecksImageLoading } =
    clincicalChecksState || {};
  const { arrayImg } = nmsServiceState || {};
  const { darkMode } = appState || {};

  const [activeIndex, setActiveIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const images =
    navigateFrom === "NMS" ? arrayImg || [] : patientImage || [];

  const currentImage = images[activeIndex];

  useEffect(() => {
    setActiveIndex(0);
    setImageLoaded(false);
    setImageError(false);
  }, [images]);

  const next = () => {
    if (!images.length) return;
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prev = () => {
    if (!images.length) return;
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const showSkeleton =
    navigateFrom !== "NMS" && (isClinicalChecksImageLoading || !imageLoaded);

  return (
    <div className="nms-presc-slider">
      {images.length > 1 && !showSkeleton && (
        <div className="image-buttons">
          <button onClick={prev}>
            <i className="fa fa-solid fa-angle-left image-button"></i>
          </button>
          <button onClick={next}>
            <i className="fa fa-solid fa-angle-right image-button"></i>
          </button>
        </div>
      )}
      {showSkeleton ? (
        <div className="left">
          <div className="medicine-card customcard loading-card-one">
            <Skeleton
              sx={{ bgcolor: darkMode ? "grey.800" : "" }}
              height={700}
              animation="wave"
              variant="rounded"
            />
          </div>
        </div>
      ) : (
        <img
          src={imageError || !currentImage ? noimage : currentImage}
          alt=""
          className="img-div"
        />
      )}
      {currentImage && (
        <img
          src={currentImage}
          alt=""
          style={{ display: "none" }}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageLoaded(true);
            setImageError(true);
          }}
        />
      )}
    </div>
  );
}

export default ImageSlider;
